import { DayOfWeek, daysOfWeek, Language } from '@altify/utils';
import { content } from './weekdays.content';

export function getWeekdayName(weekday: DayOfWeek, language: Language) {
  return content[language][weekday].long;
}

function getPreviousWeekday(weekday: DayOfWeek) {
  return daysOfWeek[daysOfWeek.indexOf(weekday) - (1 % 7)];
}
